import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Provides the feature-level translations for a lazy route, extending the
 * translations already loaded by the root `TranslateModule.forRoot()`. Use in a
 * route's `providers` array instead of repeating the
 * `importProvidersFrom(TranslateModule.forChild(...))` boilerplate.
 */
export function provideFeatureTranslations(): EnvironmentProviders {
    return importProvidersFrom(TranslateModule.forChild({ extend: true }));
}
